var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFileRenew = function SvgFileRenew(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 30",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "file_renew_svg__a",
    width: 30,
    height: 30,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#file_renew_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3 3.125q.458 0 .872.176t.723.483l5.82 5.821a2.25 2.25 0 0 1 .66 1.594v13.416q0 .948-.656 1.604a2.18 2.18 0 0 1-1.604.656H7.885a2.18 2.18 0 0 1-1.604-.656 2.18 2.18 0 0 1-.656-1.604V5.385q0-.947.656-1.604a2.18 2.18 0 0 1 1.604-.656zm-5.35 10.823a.74.74 0 0 0-.545.233l-1.471 1.493a.62.62 0 0 0-.184.45q0 .265.184.45a.62.62 0 0 0 .446.19.6.6 0 0 0 .445-.181l.358-.361v.11q0 1.98 1.42 3.38 1.422 1.4 3.41 1.4.396 0 .784-.064.387-.064.762-.197a.64.64 0 0 0 .409-.41.7.7 0 0 0-.059-.597.77.77 0 0 0-.459-.38 1.07 1.07 0 0 0-.622-.007 3 3 0 0 1-.4.082 3 3 0 0 1-.415.024q-1.372 0-2.334-.95a3.12 3.12 0 0 1-.963-2.305v-.086l.35.352a.6.6 0 0 0 .45.186.6.6 0 0 0 .449-.186.62.62 0 0 0 .183-.45.62.62 0 0 0-.183-.45l-1.472-1.493a.74.74 0 0 0-.544-.233m4.037-2.56a4.7 4.7 0 0 0-1.558.267.64.64 0 0 0-.404.411.68.68 0 0 0 .059.59q.156.285.463.38.306.096.625.007.2-.057.4-.082t.415-.024q1.372 0 2.338.95.967.953.967 2.305v.086l-.35-.361a.6.6 0 0 0-.449-.185.6.6 0 0 0-.45.185.62.62 0 0 0-.184.454q0 .269.184.454l1.472 1.494q.23.225.54.229a.72.72 0 0 0 .54-.229l1.471-1.485a.62.62 0 0 0 .184-.454.62.62 0 0 0-.184-.454.6.6 0 0 0-.446-.186.6.6 0 0 0-.445.186l-.35.352v-.111q0-1.98-1.425-3.379t-3.413-1.4"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFileRenew);
export default ForwardRef;